import dompurify from "dompurify";
import type { DOMNode } from "html-react-parser";
import parse from "html-react-parser";
import type { ReactNode } from "react";
import type React from "react";

export function parseHtml(
  html: string,
  replacer?: (node: DOMNode) => React.JSX.Element | undefined,
): string | ReactNode | ReactNode[] {
  return parse(
    dompurify.sanitize(html, {
      ALLOWED_TAGS: [
        "address",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "hgroup",
        "section",
        "blockquote",
        "dd",
        "div",
        "dl",
        "dt",
        "figcaption",
        "figure",
        "hr",
        "li",
        "ol",
        "p",
        "pre",
        "ul",
        "a",
        "abbr",
        "b",
        "bdi",
        "bdo",
        "br",
        "cite",
        "code",
        "data",
        "dfn",
        "img",
        "em",
        "i",
        "kbd",
        "mark",
        "q",
        "rb",
        "rp",
        "rt",
        "rtc",
        "ruby",
        "s",
        "samp",
        "small",
        "span",
        "strong",
        "sub",
        "sup",
        "time",
        "u",
        "var",
        "wbr",
        "caption",
        "col",
        "colgroup",
        "table",
        "tbody",
        "td",
        "tfoot",
        "th",
        "thead",
        "tr",
      ],
      ALLOWED_ATTR: ["href", "name", "target", "src", "style"],
    }),
    {
      trim: true,
      replace: replacer,
    },
  );
}
